//Ajax Cart Count Function End

function updateMiniCart(currentThis) {
  $.ajax({
    type: "GET",
    url: "/",
    dataType: "html",

    success: function (data) {
      var miniCartHead = $(data)
        .contents("#CartDrawer")
        .find(".drawer__inner")
        .html();
      $("#CartDrawer .drawer__inner").html(miniCartHead);
    },
  });
}

async function ajaxAddToCartProduct(currentThis, dynamicData) {
  try{
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dynamicData[0]),
  })
      $(".loading-overlay__spinner").addClass("hidden");
      $(".cdk_custom_add .btn_text, .cdk-addToCart .btn_text, .cdk_quickView .btn_text, .cdk_addtoCart .btn_text").removeClass("hidden");
      $(".cdk_custom_add, .cdk-addToCart").removeClass("is-loading");
      $('.grid__item .quick-view-wrapper').hide();
      updateMiniCart(currentThis);
      cartCount();
      Alpine.store('cart').toggleCartDrawer();
      
  } catch (error){
    $(".loading-overlay__spinner").addClass("hidden");
    $(".cdk_custom_add, .cdk-addToCart").removeClass("is-loading");
    $(".cdk_custom_add .btn_text, .cdk-addToCart .btn_text, .cdk_quickView .btn_text, .cdk_addtoCart .btn_text").removeClass("hidden");
  }
}
//Ajax Cart Count Function Start
function cartCount() {
  $.getJSON("/cart.js", function (cart) {
    $(".cart-count-bubble > span").html(cart.item_count);
    if (cart.item_count >= 1) {
      $("cart-drawer.cdesk-cart-drawer").removeClass("is-empty").addClass("active");
      $("body").addClass("overflow-hidden");
      $("#cart-icon-bubble").append('<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true">' +cart.item_count +'</span><span class="visually-hidden">' +cart.item_count +" items</span></div>"
      );
    }
  });
}
 
// Description splitig

(function ($) {
  var sectionsSetUp = function () {
    var sections = { "essential-info": [] };
    var header = "essential-info";
    $(".product__info-container .product__description > *").each(function (el) {
      var thisEl = $(this)[0];
      if (thisEl.nodeName.toLowerCase() === "h2") {
        header = thisEl.textContent;
        sections[header] = [];
      }
      if (sections[header]) sections[header].push(thisEl);
    });
    return sections;
  };

  var layoutSetUp = function (sections) {
    for (var section in sections) {
      if (section === "essential-info") continue;
      var className = section.toLowerCase().split(" ").join("-");

      var container = $(".enhanced-description-wrapper.desktop .body ");
      var containerMob = $(".custom_product_information_mob .tab_mob");
      container.append(
        $(`<section class=${className} data-tab=${className}></section>`)
      );
      containerMob.append(
        $(`<section class=${className} data-tab=${className}><div style="display:none;"></div></section>`)
      );
      sections[section].forEach(function (el) {
        if (el.nodeName.toLowerCase() === "h2") {
          $(".enhanced-description-wrapper .headers").append($(el).clone().addClass(className).attr("data-tab", className));
          $(`.custom_product_information_mob .tab_mob .${className}`).prepend(
            $(el).clone().addClass(className).attr("data-tab", className)
          );
        } else {
          $(`.enhanced-description-wrapper .body .${className}`).append($(el).clone());
          $(`.custom_product_information_mob .tab_mob .${className} div`).append($(el).clone());
        }
      });
    }
    var divLength = $('.enhanced-description-wrapper.desktop.noFaqs').length;
    //console.log('divLength::'+divLength);
    if(divLength == 1){
    $(".enhanced-description-wrapper .headers > *:nth-child(2)").addClass("active");
    $(".enhanced-description-wrapper .body section:nth-of-type(1)").addClass("active");
    }else{
    $(".enhanced-description-wrapper .headers > *:nth-child(3)").addClass("active");
    $(".enhanced-description-wrapper .body section:nth-of-type(2)").addClass("active");  
    }
    
  };

  var sections = sectionsSetUp();
  layoutSetUp(sections);
})(jQuery);
// end Description splitig

function addItemToCart(GiftId, GiftQty) {
  Giftdata = {
    id: GiftId,
    quantity: GiftQty 
  };

  $.ajax({
    type: "GET",
    url: "/cart/add.js",
    data: Giftdata,
    dataType: "json",
    success: function () {
        window.location = '/checkout?discount=FREEPRODUCT';
    },
  });
  
}
// Description tab desktop
$(document).ready(function () {
  
  // Impact report

  $(document).on("click", ".story-progress-bar-line li", function () {
    //console.log("click");
    var selectID = $(this).attr("tabsselectid");
    //console.log(selectID);
    $(".story-progress-bar-line li").removeClass("selected");
    $(".mission-clean-wrapper").hide();
    $(this).addClass("selected");
    $('.mission-clean-wrapper[tabid="' + selectID + '"]').css("display", "flex");
  });
  // end impact report

  $(".information-selector").click(function () {
    var t = $(this).attr("id");
    //console.log(t);
    $(".information-selector").siblings().removeClass("active");
    $(this).addClass("active");
    $(".information-about").hide();
    $("#" + t + "C").fadeIn("slow");
  });

  $(document).on("click", ".faq-ques", function () {
    $(this).parents(".faq-ques-ans").siblings(".faq-ques-ans").find(".faq-ques").removeClass("active");
    $(this).parents(".faq-ques-ans").siblings(".faq-ques-ans").find(".faq-ans").slideUp();
    $(this).toggleClass("active");
    $(this).parents(".faq-ques-ans").find(".faq-ans").slideToggle();
  });

  // quickwrapper
  $(document).on("click", ".cdk-selected-option:not(.active)", function () {
    $(".swatches-block-box").slideUp();
    $('.cdk-selected-option').removeClass("active");
    $(this).addClass("active");
    $(this).next(".swatches-block-box").slideDown();
  });
  $(document).on("click", ".cdk-selected-option.active", function () {
    $('.cdk-selected-option').removeClass("active");
    $(".swatches-block-box").slideUp();
  });
  $(document).on("click", ".swatches-block-box .swatches-option", function () {
    var thisText = $(this).text();
    $(this).parents(".swatches-block-box").slideUp();
    // $(this).next('.swatches-block-box').toggle();
    $(this).parents(".swatches-block").find(".cdk-selected-option .cdk-selected-option_item").text(thisText);
  });
  $(document).on("click",".quick-view-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
      var OptionName = $(this).attr("data-value");
      $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
      $(this).addClass("selected");
      $(this).parents(".swatches-block").find("select").val(OptionName).change();
      console.log("OptionName::" + OptionName);
    });

  $(document).on("change",".quick-view-wrapper .swatches-block select",function () {
      var FinalValue = "";
      var thisParentId = $(this).parents(".quick-view-wrapper").attr("data-id");
      $('.quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').each(function () {
        var selectVal = $(this).find("select").val();
        FinalValue += selectVal + " / ";
      });
      var newstr = FinalValue.substring(0, FinalValue.length - 3);
      var optionName_Selector = $('.quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select option[check-data-sku="' +newstr +'"]'
      );
      var optionName_val = optionName_Selector.val();
      $('.quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select').val(optionName_val).change();
    });

  $(document).on("change",".quick-view-wrapper select.product_card-form__master-select",function () {
      var thisMainVal = $(this).val();
      var thisParentId = $(this).parents(".quick-view-wrapper").attr("data-id");
      // console.log("thisMainVal::" + thisMainVal);
      // console.log("thisParentId::" + thisParentId);
      var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
      var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
      // console.log("ThisProdNP::" + ThisProdNP);
      $('.quick-view-wrapper[data-id="' + thisParentId + '"]').find(".cdk_quick_price").find(".price-item").text(ThisProdNP);
      $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-variant",thisMainVal);
      if (ThisProdAvail == "true") {
        $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","addToCart");
      } else {
        $('.cdk_custom_add[data-id="' + thisParentId + '"]').find(".btn_text").text("Sold Out");
        $('.cdk_custom_add[data-id="' + thisParentId + '"]').attr("data-btn","soldout");
      }
  
      $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-variant', thisMainVal);
      if (ThisProdAvail == 'true'){        
         $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Add To Basket');        
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'addToCart');
      }else{
        $('.cdk_quickView[data-id="'+thisParentId+'"]').find('.btn_text').text('Sold Out');
         $('.cdk_quickView[data-id="'+thisParentId+'"]').attr('data-btn', 'soldout');
      } 
    
    });

  $(document).on("click",'.cdk_custom_add[data-btn="addToCart"], .cdk-addToCart',function () {
      var currentThis = $(this);
      var updateItems = [];
      var variantId = $(this).attr("data-variant");
      var bundleId = $(this).attr("data-bundle");
      var quantity = 1;
      if (bundleId !== undefined && bundleId !== null) {
        updateItems.push({ id: variantId, quantity: quantity, properties: {_bundleID: bundleId} });
    } else {
        updateItems.push({ id: variantId, quantity: quantity });
    }
    
      ajaxAddToCartProduct(currentThis, updateItems);
      currentThis.addClass("is-loading");
      currentThis.find(".loading-overlay__spinner").removeClass("hidden");
      currentThis.find(".btn_text").addClass("hidden");
    $('.cdesk-cart-drawer').addClass('cdkCart-wrapper');
    
    });
  
  $(document).mouseup(function(e){
      var container = $(".product-card-wrapper");
   
      // If the target of the click isn't the container
      if(!container.is(e.target) && container.has(e.target).length === 0){
        $('.grid__item .cdk_quickView').attr('data-btn', 'quickview');
        $('.grid__item .quick-view-wrapper').hide();  
      }
  });
  
  $(document).on('click','.button-shop--now[data-btn="quickview"]',function(){   
    $('.grid__item .cdk_quickView').attr('data-btn', 'quickview');
    $('.grid__item .quick-view-wrapper').hide();  
    $(this).parents('.grid__item').find('.quick-view-wrapper').show();  
    var thisParentId = $(this).attr('data-id');
    $('.quick-view-wrapper[data-id="'+thisParentId+'"] select.product_card-form__master-select').change();
  });

  $(document).on('click','.button-shop--now[data-btn="addToCart"]',function(){
    var currentThis = $(this);
      var updateItems = [];
      var variantId = $(this).attr("data-variant");
      var bundleId = $(this).attr("data-bundle");
      var quantity = 1;
      if (bundleId !== undefined && bundleId !== null) {
        updateItems.push({ id: variantId, quantity: quantity, properties: {_bundleID: bundleId} });} 
      else {
        updateItems.push({ id: variantId, quantity: quantity });
      }
      ajaxAddToCartProduct(currentThis, updateItems);
      currentThis.addClass("is-loading");
      currentThis.find(".loading-overlay__spinner").removeClass("hidden");
      currentThis.find(".btn_text").addClass("hidden");
    $('.cdesk-cart-drawer').addClass('cdkCart-wrapper');    
    
  });
  
  $(".quick-view-wrapper .cdk_close_icon").click(function(){  
    $('.grid__item .cdk_quickView').attr('data-btn', 'quickview');
    $('.grid__item .quick-view-wrapper').hide(); 
  });
  // end quickwrapper

  $("input.product-variant-id").change(function () {
    //console.log("varid::" + $(this).val());
    var vari_Id = $(this).val();
    var jsonText = $("script[data-product-inventory-json]").html();
    var jsonData = JSON.parse(jsonText);
    var variantData = jsonData.variant;
    var value = variantData[vari_Id];
    
    console.log("Reg value::" + value.rprice);
    console.log("Comp value::" + value.cprice);

      $(".cdkStickyPrice").find(".cdk_quick_price").find(".price-item--regular").text(value.rprice);
      $(".cdkStickyPrice").find(".cdk_quick_price").find(".price__sale").text(value.cprice);

});



  // video list
  $(document).on("click", ".cover_image .video-play", function () {
    $(this).parents(".cover-img-video").find("video").trigger("play");
    $(this).parents(".cover-img-video").find(".cover_image").hide();
    $(this).parents(".video").siblings().find(".cover-img-video video").trigger("pause");
    $(this).parents(".video").siblings().find(".cover-img-video .cover_image").show();
  });
  $(".video .video-sound").click(function (e) {
    var VideoSoundD = $(this).parents(".cover-img-video").find("video");
    if (VideoSoundD.prop("muted", true)) {
      VideoSoundD.prop("muted", false);
    } else VideoSoundD.prop("muted", false);
    {
      VideoSoundD.prop("muted", true);
    }
  });

  //end video list
  
  
  $(document).on("click",".enhanced-description-wrapper .headers h2",function () {
    var TabheadID = $(this).attr("data-tab");
    //console.log(TabheadID);
    $(".enhanced-description-wrapper .headers h2").removeClass("active");
    $(".enhanced-description-wrapper .body section").hide();
    $(this).addClass("active");
    $('.enhanced-description-wrapper .body section[data-tab="' +TabheadID +'"]').show();
  });

// End description tab desktop

// Description tab mobile

  $(document).on("click", ".tab_mob section > h2:not(.active)", function () {
    $(".tab_mob section > h2 , .mob_faq .mob_faq_heading").removeClass("active");
    $(".tab_mob section > div, .mob_faq .mob_faq_heading ~ div").slideUp();
    $(this).addClass("active");
    $(this).next("div").slideDown();
  });
  
  $(document).on("click", ".tab_mob section > h2.active", function () {
    $(this).removeClass("active");
    $(this).next("div").slideUp();
  });
  
  $(document).on("click", ".mob_faq .mob_faq_heading:not(.active)", function () {
    $(".tab_mob h2").removeClass("active");
    $(".tab_mob section > h2 ~ div").slideUp();
    $(this).addClass("active");
    $(this).next().slideDown();
  });
  
  $(document).on("click", ".mob_faq .mob_faq_heading.active", function () {
    $(this).removeClass("active");
    $(this).next().slideUp();
  });

// End description tab mobile

// End description splitig

//  cart-drower-gift card

  // $(document).on("click", ".tab-content-for-gift .untouchable", function () {
  //   $(this).parents(".tab-content-for-gift").find('.error_cart').show();
  // });
  
  
  // $(document).on("click", ".select-gift-card .gift-card-text", function () {
  //   $(this).toggleClass("active");
  //   $(".tab-content-for-gift").slideToggle();
  // });
  $(document).on("click", "#CartDrawer-Checkout", function (e) {
    e.preventDefault();
    var GiftId = $('.select-gift-card .gift-card-all-text-icon input:checked').val();
    //console.log('GiftId::'+ GiftId);
    var GiftQty = 1;
    if(GiftId != undefined){
      addItemToCart(GiftId, GiftQty); // paste your id product number  
    }else{
      window.location = '/checkout';      
    }
  });

  $(document).on("click", ".cdk-qty-selector:not(.active)", function () { 
    $(this).addClass('active');
    $(this).next('.cdk-qty-option').slideDown();
  });
   $(document).on("click", ".cdk-qty-option ul li ", function () {
    var thisVal = $(this).attr('data-value');
    $(this).parents('.cdk-qty-wrapper').find('.cdk-qty-selector .cdk-qty-value').text(thisVal);
     $('.product-form__quantity .quantity__input').val(thisVal);
     $('.cdk-qty-selector').removeClass('active');
    $('.cdk-qty-option').slideUp();
  });
  $(document).on("click", ".cdkCart-wrapper cart-remove-button", function (event) {
    event.preventDefault();    
    var vId = $(this).parents(".cart-item__quantity-wrapper").find('.quantity__input').attr('data-quantity-variant-id');      
   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
     data: {
    'id': parseFloat(vId),
    'quantity': 0
    }
   })
   .then(data => {
     $(this).parents('.cart-item').remove();
     var Lenght = $('.cart-items .cart-item').length;
     //console.log("Lenght::"+Lenght);
     cartCount();
     updateMiniCart();
     
    
     if (Lenght == 0){
       $('cart-drawer.cdkCart-wrapper').addClass('is-empty');
     }
  })
  });
$(document).on("change", ".cdkCart-wrapper .cart-quantity .quantity__input", function (event) {
    event.preventDefault();    
    var vId = $(this).attr('data-quantity-variant-id'); 
    var itemValue = $(this).val();
   //console.log("itemValue::"+itemValue);
   $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: {'id': vId,
    'quantity': itemValue},
      success: function(data) { 
         cartCount();
         updateMiniCart();
      },
      error: function(jqxhr, status, exception) {
          //console.log('exception error True');
        } 
    });
  });
  $(document).mouseup(function (e) {
    var checkExist1 = setInterval(function() {
    if ($(e.target).closest(".find_drawer").length === 0) {
      $(".find_drawer").hide();
      clearInterval(checkExist1);
    }
    },5000);
  });

  $(document).mouseup(function(e){
    var container = $(".swatches-block .cdk-selected-option");

    // If the target of the click isn't the container
    if(!container.is(e.target) && container.has(e.target).length === 0){
       $('.swatches-block-box').hide();
      $('.cdk-selected-option').removeClass('active');
    }
  });
   $(document).mouseup(function(e){
    var container = $(".cdk-qty-wrapper .cdk-qty-option");

    // If the target of the click isn't the container
    if(!container.is(e.target) && container.has(e.target).length === 0){
       $('.cdk-qty-option').hide();
      $('.cdk-qty-selector').removeClass('active');
    }
  });
  
  $(document).on("change", ".cdk-product .product-form__input .select select", function(event) {
    event.preventDefault();
    $('.cdk-qty-selector .cdk-qty-value').text(1);
  });
 
  
  $(document).on("click",".app_reviews",function(event) {
    event.preventDefault();
    event.stopPropagation();
    $('html, body').animate({
        scrollTop: $("#app_reviews").offset().top - 130
    }, 1000);
  });
  $(document).on("click", ".forgot-ps", function () {
    $(".seep-login .col-5").addClass('rest-password');
    $(".register_image").show();
    $(".login_image").hide();
  });
  $(document).on("click", ".back-to-login .cancel", function () { 
    $(".seep-login .col-5").removeClass('rest-password');
    $(".register_image").hide();
    $(".login_image").show();
  });
  var currentUrl = window.location.href;
  var staticUrl = 'https://theseepcompany.com/account/login#recover'
  // console.log("currentUrl::"+ currentUrl);
  if (currentUrl == staticUrl){
     $(".seep-login .col-5").addClass('rest-password');
     $(".register_image").show();
    $(".login_image").hide();
  }
  
  $(".custom-blog-banner .newsletter-form .newsletter-form__button").click(function(){
     if ($('.form-checkbox #notifiy').prop('checked')) {
          $(".custom-blog-banner .newsletter-form").submit(); 
     }
    else{
      $('.custom-blog-banner .cdk-form--error').show();
    }
    });
  $(".new-footer-newsletter .newsletter-form__button").click(function(){
     if ($('.form-checkbox #notifiy_footer').prop('checked')) {
          $(".new-footer-newsletter .newsletter-form").submit(); 
     }
    else{
      $('.new-footer-newsletter .cdk-form--error').show();
    }
    });
  $(".newsltr__form .newsletter-form__button").click(function(){
     if ($('.form-checkbox #notifiy_newsltr').prop('checked')) {
          $(".newsltr__form .newsletter-form").submit(); 
     }
    else{
      $('.newsltr__form .cdk-form--error').show();
    }
  });

  $(document).on("click", ".close_sticky", function () {
    $(".product-sticky-add-to-cart").addClass("close_sticky_add");
  });
  
  $(".brand-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 581,
        settings: {
          slidesToShow: 1.7,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(window).on("resize", function() {
    $(".brand-slider").slick("resize")
  });
  setTimeout(function () {
    $(".text-slider").slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 15000,
      pauseOnHover: false,
      cssEase: "linear",
      variableWidth: true,
    });

    $(".new-banner").slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: true,
      prevArrow:'<svg class="left-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.79961L12 -0.000391006C12 -0.000391006 9.86594 3.19721 8.31579 5.11341C7.44536 6.18938 6 7.79961 6 7.79961C6 7.79961 7.46902 9.19375 8.31579 10.1698C9.99988 12.111 12 15.5996 12 15.5996L0 7.79961Z" fill="#0D2F3E"/></svg>',
      nextArrow:'<svg class="right-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.79961L0 -0.000391006C0 -0.000391006 2.13406 3.19721 3.68421 5.11341C4.55464 6.18938 6 7.79961 6 7.79961C6 7.79961 4.53098 9.19375 3.68421 10.1698C2.00012 12.111 0 15.5996 0 15.5996L12 7.79961Z" fill="#0D2F3E"/></svg>',
    });
    
    $(".new-banner-image-slider").slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      prevArrow:'<svg class="left-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.79961L12 -0.000391006C12 -0.000391006 9.86594 3.19721 8.31579 5.11341C7.44536 6.18938 6 7.79961 6 7.79961C6 7.79961 7.46902 9.19375 8.31579 10.1698C9.99988 12.111 12 15.5996 12 15.5996L0 7.79961Z" fill="#0D2F3E"/></svg>',
      nextArrow:'<svg class="right-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.79961L0 -0.000391006C0 -0.000391006 2.13406 3.19721 3.68421 5.11341C4.55464 6.18938 6 7.79961 6 7.79961C6 7.79961 4.53098 9.19375 3.68421 10.1698C2.00012 12.111 0 15.5996 0 15.5996L12 7.79961Z" fill="#0D2F3E"/></svg>',
    });

    $(window).on("resize", function() {
      $(".new-banner-image-slider").slick("resize")
	})

    $(".real-review-wrapper").slick({
      centerMode: true,
      centerPadding: "300px",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      prevArrow:'<svg class="left-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.79961L12 -0.000391006C12 -0.000391006 9.86594 3.19721 8.31579 5.11341C7.44536 6.18938 6 7.79961 6 7.79961C6 7.79961 7.46902 9.19375 8.31579 10.1698C9.99988 12.111 12 15.5996 12 15.5996L0 7.79961Z" fill="#0D2F3E"/></svg>',
      nextArrow:'<svg class="right-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.79961L0 -0.000391006C0 -0.000391006 2.13406 3.19721 3.68421 5.11341C4.55464 6.18938 6 7.79961 6 7.79961C6 7.79961 4.53098 9.19375 3.68421 10.1698C2.00012 12.111 0 15.5996 0 15.5996L12 7.79961Z" fill="#0D2F3E"/></svg>',
      variableWidth: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerPadding: "0",
            centerMode: false,
          },
        },
      ],
    });

    $(".cdk_product_slider").slick({
      autoplay: true,
      autoplaySpeed: 6000,
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      focusOnSelect: true,
      // prevArrow: $(".prev-btn"),
      // nextArrow: $(".next-btn"),
      asNavFor: ".cdk_product_thumb",
      adaptiveHeight: true,
    });

    $(".cdk_product_thumb").slick({
      dots: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: ".cdk_product_slider",
      centerMode: false,
      focusOnSelect: true,
      centerPadding: "20px",
      variableWidth: true,
      arrows: true,
      prevArrow:'<svg class="prev-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 7.9998L12 0.199804C12 0.199804 9.86594 3.39741 8.31579 5.3136C7.44536 6.38958 6 7.9998 6 7.9998C6 7.9998 7.46902 9.39394 8.31579 10.37C9.99988 12.3112 12 15.7998 12 15.7998L0 7.9998Z" fill="#0D2F3E"/></svg>',
      nextArrow:'<svg class="next-arrow" width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7.9998L0 0.199804C0 0.199804 2.13406 3.39741 3.68421 5.3136C4.55464 6.38958 6 7.9998 6 7.9998C6 7.9998 4.53098 9.39394 3.68421 10.37C2.00012 12.3112 0 15.7998 0 15.7998L12 7.9998Z" fill="#0D2F3E"/></svg>',
    });
    $(window).on("resize", function() {
      $(".cdk_product_slider, .cdk_product_thumb").slick("resize")
    });
  }, 500);
  $(".cdk-about .brand-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 581,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(window).on("resize", function() {
    $(".cdk-about .brand-slider").slick("resize")
  });
  

  $("ul.recently-viewed").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    mobileFirst: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 0,
    speed: 20000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });
  $(".video-list-wrapper").slick({
    slidesToShow: 5,
    // slidesToScroll: 5,
    arrows: false,
    dots: false,
    speed: 300,
    infinite: false,
    autoplaySpeed: 5000,
    autoplay: false,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3.3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerMode: true,
          centerPadding: "10px",
          variableWidth: false,
          slidesToShow: 1,
        },
      },
    ],
  });
  $(".announcement_bar").slick({
      infinite: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 1500,
      dots: false,
  });
 
});

var avalableScroll = $('#unwevering').length;

if(avalableScroll == 1){
   
var a = 0;
$(window).scroll(function() {
 
  var oTop = $('#unwevering').offset().top - window.innerHeight; 

  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-up-two').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 4000,
          easing: 'swing',
          step: function() {
            $this.text(commaSeparateNumber(Math.floor(this.countNum)));
          },
          complete: function() {
            $this.text(commaSeparateNumber(this.countNum));
            //alert('finished');
          }

        });
    });
    a = 1;
  }
 
    if (a == 1 && $(window).scrollTop() < oTop) { 
      a = 0;
    }

});

function commaSeparateNumber(val) {
  while (/(\d+)(\d{3})/.test(val.toString())) {
    val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
  }
  return val;
}
}

$(".no_cdk_slider").slick({
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    focusOnSelect: true,
    adaptiveHeight: true,
});

$(document).on("click", '.thumbnail-list.no_thumb .thumbnail',function(){
    var mainSlider = $(".no_cdk_slider .product__media-item").attr('mainSlider');
    var $thisid = $(this).attr('thumb-id');
    console.log('$thisid::'+$thisid);    
    $('.no_cdk_slider').slick('slickGoTo', $thisid);
    // $('.thumbnail-list.no_thumb .thumbnail').removeClas('active');
    // $(this).addClass('active');
});

$(".thumbnail-list.no_thumb .prev-arrow").click(function () {
    $(".no_cdk_slider").slick("slickPrev");
});

$(".thumbnail-list.no_thumb .next-arrow").click(function () {
    $(".no_cdk_slider").slick("slickNext");
});

$( document ).ready(function() { 
  $('.no_cdk_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $('.thumbnail-list.no_thumb .thumbnail').removeClass('slick_active');
    $('.thumbnail-list.no_thumb .thumbnail[thumb-id=' + currentSlide + ']').addClass('slick_active');
});
  
});
